export const ALGOLIA_APP_ID = 'LO7YR9MPLX';
export const ALGOLIA_SEARCH_KEY = '305b93a730f56d8b41cedbd2d39d7ef7';
